export default "__VITE_ASSET__LpOFzPRR__"